import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

class NRTCheckboxInput extends React.Component{

    state = {
        checked: false,
    }


    componentWillMount() {
        this.setState({
            checked: this.props.value
        })
    }

    setChecked = () => {
        this.setState(state=>({
                checked: !state.checked
            }) ,
            ()=>this.props.onChange(this.state.checked))
    }

    render() {

        const checkedCls = this.state.checked ? ' checked ' : ' '

        return (
            <div className={"nrt-checkbox "  + checkedCls }>
                <label>
                    <input
                        type={'checkbox'}
                        className={'nrt-checkbox-input ' + checkedCls}
                        onClick={this.setChecked}
                        checked={this.props.value}
                        onChange={()=>null}
                    />
                    {this.props.display}
                </label>
            </div>

        )
    }

}

NRTCheckboxInput.propTypes = {
    checked: PropTypes.bool,
    display: PropTypes.string.isRequired,
}

NRTCheckboxInput.defaultProps = {
    checked: false,
}

export default NRTCheckboxInput



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormInput/CheckboxInput/index.js